
import React, { BaseSyntheticEvent } from 'react';
import { observer } from 'mobx-react';
import '../apply-rule-modal.css';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { Utility } from '../../../../../common/utility';
import { CQAPIService } from '../../../../../services/http-api.service';
import { CQAppStore } from '../../../../../store/cq-app-store';
import { CQAppConstant } from '../../../../../app-constants';

class DynamicSourceRuleModalComponent extends React.Component<{
    selectedFormulaType: string,
    objectName: string,
    appliedRule: any,
    setRuleObject: Function,
    ruleObject: {},
    selectedTemplateName: string,
    checkValidation: Function,
    toggleModalVisibility: any
}, {
    type: string,
    dynamicSourceArray: any[],
    layoutFieldsArray: any[],
    selectedDynamicSourceObject: {
        componentname: string,
        ns: string,
        dynamicSourceString: string
    },
    isLookupFilterButtonVisible: boolean,
    isLookupFilterVisible: boolean,
    selectedLookupFilter: any[]
}> {
    private readonly layoutFieldsConfigCtrl: LayoutFieldsConfigController;
    private readonly cqUtilityClass: Utility;
    private cqService: CQAPIService;
    constructor(props: any) {
        super(props);
        this.cqUtilityClass = new Utility();
        this.state = {
            type: this.props.selectedFormulaType,
            dynamicSourceArray: [],
            layoutFieldsArray: [],
            selectedDynamicSourceObject: {
                componentname: '',
                ns: '',
                dynamicSourceString: ''
            },
            isLookupFilterButtonVisible: false,
            isLookupFilterVisible: false,
            selectedLookupFilter: ['']
        };
        this.cqService = new CQAPIService();
        this.layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
    }

    async componentDidMount() {
        await this.formDynamicSourceString();
        this.updateRuleObject(CQAppConstant.OBJECT_NAME, this.props.objectName);
        if (this.props.appliedRule) {
            const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
            const objectName: string = this.props.objectName;
            const ruleElement = { ...(ruleObject[objectName] || {})[this.props.appliedRule] };
            this.setState({
                selectedDynamicSourceObject: ruleElement.DynamicSource,
                // When a rule is saved without selecting a triggering fields, it will have no LookupFilter.
                selectedLookupFilter: Array.isArray(ruleElement.LookupFilter) ? ruleElement.LookupFilter : [''],
                isLookupFilterButtonVisible: true,
                isLookupFilterVisible: true,
            });
            this.props.setRuleObject(ruleElement);
        }
        this.fetchLookupFieldData();
        CQAppStore.loader.setVisibility(false);
    }

    public render() {
        return (
            <React.Fragment>
                <div className="slds-grid slds-m-bottom_small">
                    <div className="slds-size_6-of-12">
                        <div className="slds-form-element slds-form-element_horizontal">
                            <label className="slds-form-element__label" >Component Name</label>
                            <div className="slds-form-element__control">
                                <div className="slds-select_container">
                                    <select role="select-component" className="slds-select" onChange={e => this.addDynamicSource(e)} value={JSON.stringify(this.state.selectedDynamicSourceObject)}>
                                        <option value="">Please select</option> 
                                        {
                                            this.state.dynamicSourceArray && this.state.dynamicSourceArray.map((dynamicSource: any, index: number) => {
                                                return <option key={index} value={JSON.stringify(dynamicSource)}>{dynamicSource.dynamicSourceString}</option>;
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.isLookupFilterButtonVisible && <div className="slds-grid slds-grid_vertical slds-m-bottom_small">
                        <div className="slds-grid slds-m-bottom_small">
                            <button className="slds-button slds-button_brand" onClick={() => this.setState({ isLookupFilterVisible: true })}>
                                {CQAppConstant.ADD_TRIGERRING_FIELDS}
                            </button>
                        </div>
                        {
                            this.state.isLookupFilterVisible &&
                            this.state.selectedLookupFilter.map((selectedLookupField: string, index: number) => {
                                return (
                                    <div key={index} className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                        <div className="slds-col col-sm slds-m-bottom_small">{index + 1}</div>
                                        <div className="slds-col slds-size_5-of-12">
                                            <div className="slds-form-element">
                                                <div className="slds-form-element__control">
                                                    <div className="slds-select_container">
                                                        <select role="select-field" className="slds-select" id="select-01"
                                                            value={selectedLookupField}
                                                            onChange={e => this.onLookupFilterChanged(e, index)}>
                                                            <option value="">Select field</option>
                                                            {
                                                                this.state.layoutFieldsArray.map(field => <option key={field.fieldFullName}
                                                                    value={field.fieldFullName}>{`${field.fieldLabel} - ${field.fieldFullName}`}
                                                                </option>)
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="slds-col slds-size_2-of-12">
                                            <div className="slds-grid slds-m-bottom_xx-small">
                                                <button role="add-layout-field" className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" onClick={() => {
                                                    this.addLayoutField();
                                                }}>
                                                    <i className="cq-icon-add"></i>
                                                </button>
                                                {index !== 0 &&
                                                    <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                        this.deleteLookupFilter(index);
                                                    }}>
                                                        <i className="cq-icon-delete"></i>
                                                    </button>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                }
            </React.Fragment>
        );
    }

    /**
     * @private
     * @memberof DynamicSourceRuleModalComponent
     */
    private formDynamicSourceString = async () => {
        try {
            CQAppStore.loader.setVisibility(true);
            const dynamicSourceArray: any[] = [];
            const dynamicJsonObj: any = await this.cqService.getApexClass();
            dynamicJsonObj && dynamicJsonObj.length > 0 && dynamicJsonObj.forEach((dynamicSource: any) => {
                if (dynamicSource.Name) {
                    const dynamicSourceObject: any = {};
                    dynamicSourceObject['componentname'] = dynamicSource.Name;
                    if (dynamicSource.NamespacePrefix === null) {
                        dynamicSourceObject['ns'] = '';
                    } else {
                        dynamicSourceObject['ns'] = dynamicSource.NamespacePrefix;
                    }
                    dynamicSourceObject['dynamicSourceString'] = `${dynamicSource.Name} - ${dynamicSource.NamespacePrefix}`;
                    dynamicSourceArray.push(dynamicSourceObject);
                }
            });
            this.setState({
                dynamicSourceArray
            });
        } catch (error : any) {
            this.props.toggleModalVisibility();
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message,
                errorStatus: error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    /**
     * @private
     * @memberof DynamicSourceRuleModalComponent
     */
    private onLookupFilterChanged = (e: any, index: number) => {
        const selectedLookupFilter = [...this.state.selectedLookupFilter];
        selectedLookupFilter[index] = e.target.value;
        this.setState({
            selectedLookupFilter
        }, () => this.updateRuleObject('LookupFilter', this.state.selectedLookupFilter));
    }

    private addLayoutField = () => {
        const selectedLookupFilter = [...this.state.selectedLookupFilter];
        selectedLookupFilter.push('');
        this.setState({
            selectedLookupFilter
        }, () => this.updateRuleObject('LookupFilter', this.state.selectedLookupFilter));
    }


    private deleteLookupFilter = (index: number) => {
        let selectedLookupFilter = [...this.state.selectedLookupFilter];
        selectedLookupFilter = selectedLookupFilter.filter((fieldName: string, fieldIndex: number) => fieldIndex !== index);
        this.setState({
            selectedLookupFilter
        }, () => this.updateRuleObject('LookupFilter', this.state.selectedLookupFilter));
    }


    private fetchLookupFieldData = () => {
        // const layout = CQMasterDataStore.OutputConfig.getTemplateLayoutMetadata(this.props.selectedTemplateName);
        const layoutFields = this.layoutFieldsConfigCtrl.getLayoutFields(this.props.selectedTemplateName);
       
        // const layoutFields: any = [];
        // layout && layout.layout.layoutSections.forEach((section: any) => {
        //     section.layoutColumns && section.layoutColumns.forEach((column: any) => {
        //         layoutFields.push(column);
        //     });
        // });
        this.setState({
            layoutFieldsArray: layoutFields
        });
    }

    /**
     * @private
     * @memberof DynamicSourceRuleModalComponent
     */
    private addDynamicSource = (e: BaseSyntheticEvent) => {
        this.showLookupFilter();
        this.setState({
            selectedDynamicSourceObject: JSON.parse(e.target.value)
        }, () => this.updateRuleObject('DynamicSource', this.state.selectedDynamicSourceObject));
    }

    /**
     * @private
     * @memberof DynamicSourceRuleModalComponent
     */
    private showLookupFilter = () => {
        this.setState({
            isLookupFilterButtonVisible: true
        });
    }

    /**
     * @private
     * @memberof DynamicSourceRuleModalComponent
     */
    private updateRuleObject = (ruleObjectName: string, selectedDynamicSource: any) => {
        const ruleObject: any = { ...this.props.ruleObject };
        ruleObject[ruleObjectName] = selectedDynamicSource;
        this.props.setRuleObject(ruleObject);
        this.props.checkValidation(!this.validateAddRuleForm());
    }


    /**
     * @private
     * @memberof DynamicSourceRuleModalComponent
     */
    private validateAddRuleForm = () => {
        if (this.state.selectedLookupFilter.length > 0 && this.state.selectedDynamicSourceObject?.componentname) {
            return true;
        }
        return false;
    }

}
export const DynamicSourceModal = observer(DynamicSourceRuleModalComponent);
